import React from "react";
import {CertificationProcess} from "./CertificationProcess";

const HowItWorks: React.FC = () => {
  return (
    <section className="secondary-page">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 sm:mb-12 lg:mb-16">
          <h1>How It Works</h1>
          <div className="max-w-6xl mx-auto space-y-4 l0-section-text">
            <p>
              We provide an online certification platform that helps labs reduce their environmental impact and get
              recognised for their efforts.
            </p>
            <p>
              There are three levels to work towards: <b className="l0-emphasis">Bronze, Silver, and Gold</b>.<br />
              To complete each level you undertake the following:
            </p>
            <p>
              <ul className="l0-list-nr">
                <li><b className="l0-emphasis">Fill Out Baseline Assessment:</b> Share how your lab currently operates so we can set a starting point.</li>
                <li><b className="l0-emphasis">Complete Actions Checklist:</b> Select and complete actions that suit your team.</li>
                <li><b className="l0-emphasis">Fill Out Savings Assessment:</b> Record the improvements you’ve made.</li>
                <li><b className="l0-emphasis">Submit for Audit:</b> Your organisation conducts its own internal review.</li>
                <li><b className="l0-emphasis">Complete Audit:</b> Use our simple auditing checklist to guide the process.</li>
                <li><b className="l0-emphasis">Get Certified:</b> Achieve certification for one year, showcasing your lab’s commitment to sustainability.</li>
              </ul>
            </p>
            <p>
              We provide a checklist for auditors to run internal checks within your organisation.
            </p>
            <p>
              Think of it like the research peer review process – but much simpler, and designed to take very little time.
            </p>
          </div>
        </div>

        <div className="mb-8 sm:mb-12 lg:mb-16">
          <CertificationProcess/>
        </div>

        <div className="gap-4 sm:gap-6 md:gap-8">
          <ul className="l0-list">
            <li>Designed to minimise decision fatigue and time burden.</li>
            <li>
              Certified labs receive a <b className="l0-emphasis">digital certificate</b> valid for a year and
              a <b className="l0-emphasis">verification badge</b> to display on their email signatures and presentations!
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
